export default {"src":"/_next/static/media/arrow-up.240a878d.svg","height":18,"width":20};